
export const fieldNames = {
  NAME_OF_COMPANY: 'nameOfCompany',
  IDENTIFICATION_NUMBER: 'IdentificationNumber',
  LEGAL_FORM: 'legalForm',
  TEXT_AREA:'textArea',
};

